// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import VueCookies from 'vue-cookies'
import 'babel-polyfill'

// vuetify
import Vuetify from '@conzian/vuetify'
import '@conzian/vuetify/dist/vuetify.min.css'

// vue-resize
import VueResize from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'

// directives
import imageLazyLoad from './directives/image-lazy-load'

// router
import router from './router'
import store from '@/stores'

// custom global scss
import './scss/main.scss'

// lang settings
import i18n from '@/lang'
import { getLanguageSetting } from '@/util/helper.js'

// time handler
import conzianTimeHandler from '@/util/conzian-time-handler.js'

// localstorage can support expires
import '@/util/storage'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.directive('lazyload', imageLazyLoad)

Vue.use(Vuetify, {
  theme: {
    primary: '#2096f3',
    secondary: '#ff5722',
    error: '#ff5722', // vuetify validation failed would apply error--text
    warning: '#ffcf22',
    danger: '#dd2c00',
    success: '#7ed321',
    teal: '#00bfa5',
    'czn-blue': '#147bd1',
    'light-gray': '#d4d4d4',
    'dark-gray': '1b2733',
    'brown-gray': '#bdbdbd',
    hex333: '#333'
  }
})

Vue.use(VueResize)
Vue.use(VueCookies)
Vue.use(conzianTimeHandler)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

var isIE = /* @cc_on!@ */ false || !!document.documentMode

if (isIE) {
  const lang = getLanguageSetting()
  // window.location.href = `/static/browser_${lang}.html`
  window.location.href = '/static/browser_' + lang + '.html'
} else {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    i18n: i18n,
    // components: { App },
    // template: '<App/>'
    render: h => h(App)
  })
}



// WEBPACK FOOTER //
// ./src/main.js